class OrderDeadline extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.localeShippingGroup || !this.localeShippingGroup.id) {
      this.setAttribute('aria-hidden', '')

      return
    }

    window.orderDeadlineAppApi.setSelectedShippingGroupId(
      this.localeShippingGroup.id,
    )
    this.removeAttribute('aria-busy')
  }

  get locale () {
    return window.Shopify.country
  }

  get shippingGroups () {
    return window.orderDeadlineAppApi.getShippingGroups()
  }

  get localeShippingGroup () {
    const matchedShippingGroup = this.shippingGroups.find(group => {
      return group.countries.find(country => country.alpha2 === this.locale)
    })

    return matchedShippingGroup
  }
}

if (!customElements.get('order-deadline')) {
  customElements.define('order-deadline', OrderDeadline)
}
